import Profile from './views/profile.vue';

export default {
  path: 'profile/:id',
  name: 'profile',
  component: Profile,
};
